import { createEditorSessions } from './editor-session';
const sessions = createEditorSessions(
  {
    getItem: (name) => sessionStorage.getItem(name),
    setItem: (name, value) => sessionStorage.setItem(name, value),
  },
  navigator.locks,
  {
    getItem: (name) => localStorage.getItem(name),
    setItem: (name, value) => localStorage.setItem(name, value),
  },
);
/** A single document owner is shared by every workspace domain. */
export const editorSessionFor = (workspaceId: string) => sessions.forWorkspace(workspaceId);
// Coder must open a different workspace-file URI after an activity switch. Reusing
// the URI can retain the previous folder and extension's immutable save context.
export const workshopEditorContextKey = (workspace: {
  id: string;
  generation: number;
  activeAttemptId: string | null;
}) => `${workspace.id}:${workspace.generation}:${workspace.activeAttemptId}`;
/**
 * A Field editor workspace URI must change when Field is reactivated or its pinned
 * project changes; remote extensions retain the context they opened with. Shared so
 * the Workshop can pause Field through the same editor session this document holds.
 */
export const fieldEditorContextKey = (context: {
  workspaceId: string;
  engagementId: string;
  runtimeVersionId: string;
  generation: number;
}) =>
  `field:${context.workspaceId}:${context.engagementId}:${context.runtimeVersionId}:${context.generation}`;
/** Before a launch: adopt the accepted identity if its previous document has closed. */
export const reclaimEditorSession = (workspaceId: string) => sessions.reclaim(workspaceId);
export const rememberEditorSession = (workspaceId: string, sessionId: string) =>
  sessions.remember(workspaceId, sessionId);
/** Explicit recovery reserves a new owner; successful launch commits it. */
export const beginEditorSessionRecovery = (workspaceId: string) =>
  sessions.beginRecovery(workspaceId);
if (import.meta.hot) import.meta.hot.dispose(() => sessions.dispose());
